module.exports = __webpack_public_path__ + "img/air_green.4a7192b6.svg";